export const BACKORDERS_PAGE_SEARCH_QUERY_KEY = "search";

export const BACKORDERS_PAGE_STATUS_QUERY_KEY = "status";
export const BACKORDERS_PAGE_AVAILABILITY_QUERY_KEY = "availability";
export const BACKORDERS_PAGE_CREATE_PERIOD_QUERY_KEY = "created";
export const BACKORDERS_PAGE_MANUFACTURERS_QUERY_KEY = "manufacturers";
export const BACKORDERS_PAGE_PRODUCT_TYPES_QUERY_KEY = "producttypes";
